import Swiper from 'swiper';

const breakpoint = window.matchMedia('(max-width: 767px)');
let catalogTeacher;
// eslint-disable-next-line no-unused-vars
let courseProduct;
let catalogPromo;

const carouselProperties = {
  teachersProducts: {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 10,
    watchOverflow: true,
    observer: true,
    observeParents: true,
    autoplay: {
      delay: 3000
    },
    navigation: {
      nextEl: '.main-catalog--buttons.swiper-button-next',
      prevEl: '.main-catalog--buttons.swiper-button-prev'
    },
    pagination: {
      el: '.main-catalog--bullets',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      1: {
        slidesPerView: 1,
        slidesPerGroup: 1
      },
      768: {
        slidesPerView: 1,
        slidesPerGroup: 1
      }
    }
  },
  courseProductSlide: {
    slidesPerView: 4,
    slidesPerGroup: 1,
    spaceBetween: 20,
    watchOverflow: true,
    autoplay: {
      delay: 3000
    },
    navigation: {
      nextEl: '.horizontal--buttons.swiper-button-next',
      prevEl: '.horizontal--buttons.swiper-button-prev'
    },
    pagination: {
      el: '.swiper-pagination--catalog-news',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1
      },
      768: {
        slidesPerView: 2,
        slidesPerGroup: 1
      },
      1024: {
        slidesPerView: 3,
        slidesPerGroup: 1
      },
      1025: {
        slidesPerView: 4,
        slidesPerGroup: 1
      }
    }
  },
  promoCatalogSlide: {
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 20,
    watchOverflow: true,
    autoplay: {
      delay: 3000
    },
    pagination: {
      el: '.swiper-pagination--catalog-promo',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1
      },
      550: {
        slidesPerView: 2,
        slidesPerGroup: 1
      }
    }
  }
};

const teachersProductSlider = () => { catalogTeacher = new Swiper('.swiper-container--course-profile', carouselProperties.teachersProducts); };
const courseProductSlide = () => { courseProduct = new Swiper('.swiper-container-courses-product', carouselProperties.courseProductSlide); };

const breakpointChecker = () => {
  teachersProductSlider();
  courseProductSlide();

  if (breakpoint.matches === false) {
    if (catalogTeacher !== undefined) {
      $('.swiper-pagination--catalog-news').html('');
    }
    if (catalogPromo !== undefined) {
      $('.swiper-pagination--catalog-promo').html('');
    }
  } if (breakpoint.matches === true) {
    // catalogPromoSlide();
  }
};

breakpoint.addListener(breakpointChecker);

export default breakpointChecker;



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/courses/coursesSliders.js